import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import api from '../services/api';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { paramsToObject,  } from '../utils/functions'
import FrLoading from '../components/FrLoading'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';


const swal = withReactContent(Swal)
function Callback(props) {

  function contrato (acao, pk_cto, redirectUrl) {
    const urlParams = new URLSearchParams(window.location.search);
    let query = paramsToObject(urlParams)
    if (acao == 'A'){

      api.post('/testeSignThroughApp', {pk_cto: pk_cto, code: query.code, redirectUrl: redirectUrl}).then(r => {
        localStorage.removeItem('docusignData')
        window.location = r.data.redirectUrl
      })
    } else if (acao == 'E') {
      api.post('/testeSignThroughApp', {pk_cto: pk_cto, code: query.code, redirectUrl: redirectUrl}).then(r => {
        localStorage.removeItem('docusignData')
        window.location = redirectUrl
      })
    }
  }

  function termo (acao, pk_cto, redirectUrl) {
    const urlParams = new URLSearchParams(window.location.search);
    let query = paramsToObject(urlParams)
    if (acao == 'A'){
      api.get('/envelope', {pk_cto: pk_cto, code: query.code, redirectUrl: redirectUrl, signerEmail: 'lucas@delphus.inf.br', signerName: 'Lucas Moraes'}).then(r => {
        localStorage.removeItem('docusignData')
        window.location = r.data.redirectUrl
      })
    } else if (acao == 'E') {
      api.get('/envelope', {pk_cto: pk_cto, code: query.code, redirectUrl: redirectUrl, signerEmail: 'lucas@delphus.inf.br', signerName: 'Lucas Moraes'}).then(r => {
        localStorage.removeItem('docusignData')
        window.location = redirectUrl
      })
    }
  }

  useEffect(() => {
    const docusignData = JSON.parse(localStorage['docusignData'])
    const acao = docusignData.acao
    const operacao = docusignData.tipoDoc
    const pk_cto = docusignData.pk_cto
    const redirectUrl = docusignData.redirectUrl
    const cliente = docusignData.cliente
    swal.fire({
      html: <FrLoading text="Carregando..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.post('/envelope', {tipoDoc: operacao, pk_cto: pk_cto, redirectUrl: redirectUrl}).then(r => {
      console.log(r.status, r.data)
      if (r.data.consentUrl) {
        window.location = r.data.consentUrl
      } else if (r.data.signingUrl) {
        window.location = r.data.signingUrl
      }
    })
    
  }, [])

  return <></>
}

export default Callback;
